window.confirmForm = function (message, route, method = 'POST') {

    if (!confirm(message)) {
        return
    }

    window.submitForm(route, method)
}

window.submitForm = function (route, method = 'POST') {

    let form = document.createElement('form')
    let eMethod = document.createElement('input')
    let eCsrf = document.createElement('input')

    form.method = 'POST'
    form.action = route

    eMethod.value = method
    eMethod.name = '_method'
    form.appendChild(eMethod)

    eCsrf.value = document.head.querySelector('meta[name="csrf-token"]').content
    eCsrf.name = '_token'
    form.appendChild(eCsrf)

    document.body.appendChild(form)

    form.submit()
}
